import groq from 'groq'
import { callToAction } from './callToAction.js'

export function menu() {
	return groq`*[_type == 'sharedContent'][0].navigation {
		item{...${callToAction()}},

		main[]{...${callToAction()}},
		secondary[]{...${callToAction()}},
	}
`
}
